import { Col, Form, FormFeedback, Label,
         Modal, ModalBody, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React, { useState } from "react"
import Select from 'react-select';
import { useFormik } from "formik";
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';
import { MODE } from "helpers/sf_constants";
import { getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect } from "react";
import { optionsViolationDesc, optionsViolationTypes } from "helpers/sf_lead_constants";
import NumberFormat from "react-number-format";
import { format, subMonths } from 'date-fns';


const AddViolationModal = ({ title, leadApplicants, show, onClickSaveViolation, onCloseClick }) => {

    //setting value of description
    const dateFromSixMonthsAgo = format(subMonths(new Date(), 6), 'MM-dd-yyyy')

    const [selectedViolationType, setSelectedViolationType] = useState(null);
    const [showAmountPaid, setShowAmountPaid] = useState(false)
    const [optionsDrivers, setOptionsDrivers] = useState([])
    const [descOptions, setDescOptions] = useState({})

    const [date, setDate] = useState(show?.mode === MODE.EDIT ? format(new Date(show?.values?.dt), 'MM-dd-yyyy') : dateFromSixMonthsAgo);

    useEffect(() => {
        if (show?.values?.dt && Date.parse(show?.values?.dt)) {
            setDate(format(new Date(show?.values?.dt), 'MM-dd-yyyy'))
        }else {
            setDate(dateFromSixMonthsAgo)
        }
    }, [show?.values?.dt]);



    useEffect(() => {
        if (leadApplicants) {
            const options = leadApplicants.map(LA => ({ label: `${LA.first_name}
                                                 ${LA.last_name}`, value: LA.id }))
            setOptionsDrivers(options)
        }
    }, [leadApplicants])

    useEffect(() => {
        if (show?.values?.violation_type_id) {
            let selectedVio = optionsViolationTypes.find(e => e.value === show?.values?.violation_type_id)
            setSelectedViolationType(selectedVio);
        }
    }, [show]);

    useEffect(() => {
        if (selectedViolationType) {
            let desOptions = optionsViolationDesc?.filter(option => option?.violation_id === selectedViolationType?.value)
            setDescOptions(desOptions)
            //Checking if violation type is Claim/Accident
            //TODO: Use constants
            if (selectedViolationType?.value === 2 || selectedViolationType?.value === 3)
            {
                setShowAmountPaid(true)
            }else{
                setShowAmountPaid(false)
            }
            const event = {
                target: {
                    name: 'desc',
                    value: desOptions[0],
                },
            };
            validation.handleChange(event);
        }
    }, [selectedViolationType]);

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            id: show?.mode === MODE.EDIT ? show?.values?.id : null,
            lead_applicant_id: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsDrivers, show?.values?.lead_applicant_id) : null,
            dt: date,
            paid_amount: show?.mode === MODE.EDIT ? show?.values?.paid_amount : "",
            violation_type_id: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsViolationTypes, show?.values?.violation_type_id) : null,
            desc: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsViolationDesc, show?.values?.desc) : null,
        },
        validationSchema: Yup.object({
            lead_applicant_id: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
            violation_type_id: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
            desc: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
            dt: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_FIELD)
                .matches(
                /^(0?[1-9]|1[0-2])-(0?[1-9]|[1-2][0-9]|3[0-1])-(19\d{2}|20\d{2})$/,
                'Please enter a valid date'
            ),
        }),
        onSubmit: (values) => {
            const data =
            {
                ...values,
                dt: format(new Date(values.dt), 'dd-MM-yyyy'),
                violation_type_id: values.violation_type_id.value,
                lead_applicant_id: values.lead_applicant_id.value,
                desc: values.desc.value
            }
            onClickSaveViolation(show?.mode, data);
        },
    });


    return (
        <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='xl'>
            <ModalHeader>
                <div className="d-flex justify-content-center">
                    <i className={`align-self-bottom label-title bx bx-users ${getPrimaryTextClass()} me-1`}></i>
                    <span className="modal-title font-weight-semibold text-black">
                        {title}
                    </span>
                </div>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={onCloseClick}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={e => {
                        e.preventDefault();
                        validation.handleSubmit()
                        return false
                    }}
                >
                    <Row className="mx-2">
                        <Col md={6} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Driver</Label>
                                    <Select
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        options={optionsDrivers}
                                        onChange={(selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: 'lead_applicant_id',
                                                    value: selectedOption,
                                                },
                                            };
                                            validation.handleChange(event);
                                        }}
                                        onBlur={() => {
                                            validation.handleBlur({
                                                target: { name: 'lead_applicant_id' },
                                            });
                                        }}
                                        value={validation.values.lead_applicant_id || ''}
                                        invalid={
                                            !!(validation.touched.lead_applicant_id
                                                && validation.errors.lead_applicant_id)
                                        }
                                    />
                                {validation.touched.lead_applicant_id
                                    && validation.errors.lead_applicant_id ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Violation Type</Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={optionsViolationTypes}
                                    onChange={(selectedOption) => {
                                        setSelectedViolationType(selectedOption);
                                        const event = {
                                            target: {
                                                name: 'violation_type_id',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);

                                        // ALSO CHANGE DESC

                                        const event_desc = {
                                            target: {
                                                name: 'desc',
                                                value: descOptions[0],
                                            },
                                        };
                                        validation.handleChange(event_desc);


                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'violation_type_id' },
                                        });
                                    }}
                                    value={validation.values.violation_type_id || null}
                                    invalid={
                                        !!(validation.touched.violation_type_id
                                            && validation.errors.violation_type_id)
                                    }
                                />
                                {validation.touched.violation_type_id
                                    && validation.errors.violation_type_id ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            {showAmountPaid == true ?
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Amount Paid</Label>
                                <NumberFormat
                                    type="text"
                                    name="paid_amount"
                                    className="form-control"
                                    thousandSeparator
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    prefix="$"
                                    onValueChange={(values) => {
                                        const {value} = values;
                                        const event = {
                                            target: {
                                                name: 'paid_amount',
                                                value: value,
                                            },
                                        };
                                        validation.handleChange(event);
                                       
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.paid_amount || ''}
                                    invalid={
                                        !!(validation.touched.paid_amount
                                            && validation.errors.paid_amount)
                                    }
                                />
                                {validation.touched.paid_amount
                                    && validation.errors.paid_amount ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.paid_amount}
                                    </FormFeedback>
                                ) : null}
                            </Col>
                            :
                            ''
                            }
                        </Col>
                        <Col md={6} className='pe-3'>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Date</Label>
                                <NumberFormat
                                    type="text"
                                    name="dt"
                                    format="##-##-####"
                                    mask={['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y']}
                                    placeholder="MM-DD-YYYY"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.dt || ''}
                                    invalid={
                                        !!(validation.touched.dt
                                            && validation.errors.dt)
                                    }
                                />
                                {validation.touched.dt
                                    && validation.errors.dt ? (
                                    <span className="text-danger" type="invalid">
                                        {validation.errors.dt}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Description</Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={descOptions}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: 'desc',
                                                value: selectedOption,
                                            },
                                        };
                                        validation.handleChange(event);
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: 'desc' },
                                        });
                                    }}
                                    value={validation.values.desc || null}
                                    invalid={
                                        !!(validation.touched.desc
                                            && validation.errors.desc)
                                    }
                                />
                                {validation.touched.desc
                                    && validation.errors.desc ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <div className="text-end mt-3">
                            <button
                                type="submit"
                                name="submit"
                                className={`btn ${getPrimaryButtonClass()} ms-2`}
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                className="btn btn-light ms-2"
                                onClick={onCloseClick}
                            >
                                Cancel
                            </button>
                        </div>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

AddViolationModal.propTypes = {
    onCloseClick: PropTypes.func,
    onClickSaveViolation: PropTypes.func,
    show: PropTypes.any,
    title: PropTypes.any,
}

export default AddViolationModal;

